import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { css } from "styled-components";

sortSelectStyles.select = {
    labelProps: {
        css: css`
            width: unset;
            width: auto;
            font-style: italic;
            font-weight: normal;
        `,
    },
};
